import { AloftDate } from '@aloft/toolkit-shared';

import { LocationType } from './locationTypeProximityRequirementMiles.ts';

const parseAloftDateFormValue = (value: unknown): AloftDate | undefined => {
  if (value === undefined || value === null || value === '') return undefined;
  const parsed = AloftDate.schema.safeParse(value);
  return parsed.success ? parsed.data : undefined;
};

export const getLocationTypeSaleDateRequirementMonths = (
  locationType: LocationType | undefined,
): number | undefined => {
  if (!locationType) return undefined;
  switch (locationType) {
    case 'Urban':
      return 6;
    case 'Suburban':
    case 'Rural':
      return 12;
    default:
      return undefined;
  }
};

export const formatSaleDateRequirementTooltip = (
  locationType: LocationType,
  requirementMonths: number,
): string =>
  `Exceeds ${requirementMonths} month sale date suggested for ${locationType} locations.`;

export const formatSaleDateRequirementWarning = (
  locationType: LocationType,
  requirementMonths: number,
): string =>
  `For ${locationType} locations, properties with Sale Dates within the last ${requirementMonths} months are recommended.`;

export const isSaleDateOutOfBounds = (
  saleDate: AloftDate | undefined,
  effectiveDate: AloftDate | undefined,
  requirementMonths: number | undefined,
): boolean => {
  if (!saleDate || !effectiveDate || requirementMonths === undefined) return false;
  return saleDate.compare(effectiveDate.subtractMonths(requirementMonths)) < 0;
};

const isMinMaxSaleDateRangeSpanExceedsRequirement = (
  min: AloftDate,
  max: AloftDate,
  requirementMonths: number,
) => min.addMonths(requirementMonths).compare(max) < 0;

export const isRecommendedCompFilterSaleDateOutOfPolicy = (
  saleDateMatchCriteria: string | undefined,
  saleDateFilter: { variance?: number | string; min?: unknown; max?: unknown } | undefined,
  effectiveDate: AloftDate,
  requirementMonths: number | undefined,
): boolean => {
  if (requirementMonths === undefined) return false;
  if (saleDateMatchCriteria === 'lasting_range') {
    return (
      typeof saleDateFilter?.variance === 'number' &&
      saleDateFilter.variance > requirementMonths
    );
  }
  if (saleDateMatchCriteria !== 'min_max_range' || !saleDateFilter) return false;
  const minDate = parseAloftDateFormValue(saleDateFilter.min);
  const maxDate = parseAloftDateFormValue(saleDateFilter.max);
  if (isSaleDateOutOfBounds(minDate, effectiveDate, requirementMonths)) {
    return true;
  }
  if (minDate && maxDate && isMinMaxSaleDateRangeSpanExceedsRequirement(minDate, maxDate, requirementMonths)) {
    return true;
  }
  if (minDate === undefined) {
    return true;
  }
  return false;
};
